import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Stack, Typography, Checkbox } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { formatDate, formatDateTime } from '../../../../../../services/functions';
import { getPeriodsAction, getAccomodationsAction, getPromotionsAction } from '../../../../../../services/request';
import { AutocompleteImpl } from '../../../../../../components/AutoCompleteImpl';
import { SmallFormDateField } from '../../../../../../components/small-fields/SmallFormDateField';

const WROrderDetailsForm = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);
  const { seasonIdentifier } = useSelector(state => state.app);

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack justifyContent="space-around" spacing={1} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Numer Zamówienia</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.identifier && formik.touched.identifier}
            name="identifier"
            placeholder="numer zamówienia"
            value={formik.values.identifier}
            onChange={formik.handleChange}
            helperText={formik.errors.identifier}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Data zamówienia</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SmallFormDateField
              sx={{ flex: '1 1 70%' }}
              name="created_at"
              inputFormat="yyyy-MM-dd hh:mm"
              mask="____-__-__ __:__"
              label="data zamówienia"
              value={formik.values.created_at}
              onChange={val => formik.setFieldValue('created_at', formatDateTime(val))}
              error={Boolean(formik.errors.created_at)}
            />
          </LocalizationProvider>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ośrodek</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            select
            name="resort"
            placeholder="ośrodek"
            options={order.resort_event_camp_data.resorts}
            value={formik.values.resort}
            onChange={formik.handleChange}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin</Typography>
          <AutocompleteImpl
            sx={{ flex: '1 1 70%' }}
            displayName={order.period_display}
            action={getPeriodsAction}
            fieldName="period"
            formik={formik}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Zakwaterowanie</Typography>
          <AutocompleteImpl
            sx={{ flex: '1 1 70%' }}
            displayName={order.accomodation_name}
            action={getAccomodationsAction}
            fieldName="accomodation"
            formik={formik}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin od</Typography>
          <SmallFormDateField
            sx={{ flex: '1 1 70%' }}
            name="period_from"
            id="period_from"
            type="text"
            placeholder="period_from"
            value={formik.values.period_from}
            onChange={val => formik.setFieldValue('period_from', formatDate(val))}
            error={Boolean(formik.errors.period_from)}
            helperText={formik.touched.period_from && formik.errors.period_from}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin do</Typography>
          <SmallFormDateField
            sx={{ flex: '1 1 70%' }}
            name="period_to"
            id="period_to"
            type="text"
            placeholder="period_to"
            value={formik.values.period_to}
            onChange={val => formik.setFieldValue('period_to', formatDate(val))}
            error={Boolean(formik.errors.period_to)}
            helperText={formik.touched.period_to && formik.errors.period_to}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Promocje</Typography>
          <AutocompleteImpl
            multiple
            sx={{ flex: '1 1 70%' }}
            defaultValue={
              formik.values.promotions
            }
            displayName={
              formik.values.promotions
            }
            action={getPromotionsAction}
            fieldName="promotions"
            formik={formik}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Zwierzę</Typography>
          <Checkbox
            sx={{ flex: '1 1 70%' }}
            id="wr_has_animal"
            name="wr_has_animal"
            checked={formik.values.wr_has_animal}
            onChange={formik.handleChange}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Dodatkowe informacje o zwierzęciu</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            name="wr_animal_info"
            placeholder="dodatkowe informacje"
            value={formik.values.wr_animal_info}
            onChange={formik.handleChange}
          />
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} sx={{ width: '50%' }}>
        <Typography variant="subtitle2">Uwagi</Typography>
        <SmallFormTextField name="comments" placeholder="uwagi" multiline rows={20} value={formik.values.comments} onChange={formik.handleChange} />
      </Stack>
    </Box>
  );
};

export default WROrderDetailsForm;
